// @flow

import React from "react";
import { connect } from "react-redux";

import { toggleRating, addRating } from "@src/actions";

import { Flex, Text } from "@src/common";
import { TextAreaInput } from "@src/common/textInput";

import {
  DraftComponent,
  Comment,
  Measure
} from "@src/containers/Assessment/components";
import { ContentBody, ContentHeader } from "@src/components";

import Checkbox from "material-ui/Checkbox";
import { Checked, Unchecked } from "@src/common/muiComponents/checkbox";

// Mui Checkbox style
import { muiLabelStyle } from "@src/common/theme";

const renderMeasures = (measure, measureIndex, measureKey, toggleRating) => {
  return (
    <Measure key={measureIndex} onClick={() => toggleRating(measureKey)}>
      <Checkbox
        checked={measure.checked}
        key={`${measureKey + measureIndex}`}
        disableTouchRipple
        labelStyle={muiLabelStyle}
        style={{ width: "initial" }}
        iconStyle={{ marginRight: "10px" }}
        uncheckedIcon={<Unchecked />}
        checkedIcon={<Checked />}
      />
      <Text type="book" size="5">
        {measure.text}
      </Text>
    </Measure>
  );
};

class RiskRatings extends React.Component {
  onEditorEnter = (measures, value) => {
    this.props.addMeasure(`custom${Object.keys(measures).length}`, value);
  };

  render() {
    const { section, careType, toggleRating, riskScore } = this.props;
    const { risks } = section[careType];
    const { measures, type } = risks[riskScore];

    return (
      <Flex justifyContent="flex-start" flexDirection="column">
        <ContentHeader backgroundColor="whiteGrey">
          <Text size={4} type="bold">
            {type}
          </Text>
        </ContentHeader>
        <ContentBody>
          {Object.keys(measures).map((measureKey, measureIndex) =>
            renderMeasures(
              measures[measureKey],
              measureIndex,
              measureKey,
              toggleRating
            )
          )}
          <DraftComponent
            editorPlaceHolder="Add additional cues for action"
            onEditorEnter={value => this.onEditorEnter(measures, value)}
          />
          <Comment>
            <TextAreaInput
              placeholder="Add a comment"
              onChange={this.props.onCommentChange}
              value={this.props.commentValue}
            />
          </Comment>
        </ContentBody>
      </Flex>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    toggleRating: measureKey => dispatch(toggleRating(measureKey)),
    addMeasure: (measureKey, value) => dispatch(addRating(measureKey, value))
  };
}

export default connect(() => ({}), mapDispatchToProps)(RiskRatings);



// WEBPACK FOOTER //
// ./src/containers/Assessment/ContentWrapper/Layouts/RiskRatings.jsx